import {RouteObject} from 'react-router-dom';
import AuthLayout from 'layout/auth/authLayout';
import LoginPage from './login';
import ConfirmationPage from './confirmation';
import SignUpPage from './signUp';
import RulesWrapper from './rules';
import {lazy, Suspense} from 'react';
import LogoPage from './intro/logo';

const IntroductionPage = lazy(() => import('../../modules/auth/intro/index'));

export const authRoutes: RouteObject[] = [
  {
    path: 'auth',
    element: <AuthLayout />,
    errorElement: <>error page</>,
    children: [
      {
        index: true,
        path: 'login',
        element: <LoginPage />,
      },
      {
        index: false,
        path: 'introduction',
        element: (
          <Suspense fallback={<LogoPage />}>
            <IntroductionPage />
          </Suspense>
        ),
      },
      {
        index: false,
        path: 'confirmation',
        element: <ConfirmationPage />,
      },
      {
        index: false,
        path: 'signUp',
        element: <SignUpPage />,
      },
      {
        index: false,
        path: 'rules',
        element: <RulesWrapper />,
      },
    ],
  },
];
